import {
  ERR_NETWORK,
  ERR_CANCELED,
  ECONNABORTED,
  ETIMEDOUT,
} from '../../constants/HttpConstants';
import { Dictionary } from '../../types/utils.types';
import { DO_CENTRAL_SERVICE_URL } from '../../constants/AppConstants';
import { IRedirectionState } from '../../types/utils/apiHelper.types';
import { template } from '../../utils/utils';

export const GENERIC_ERROR_MESSAGES = {
  500: {
    message:
      'The server encountered an error and could not complete your request. If issue persists please contact support@doselect.com',
  },
  503: {
    message:
      'The server encountered an error and could not complete your request. If issue persists please contact support@doselect.com',
  },
  504: {
    message:
      'The server encountered an error and could not complete your request. If issue persists please contact support@doselect.com',
  },
};

export const NETWORK_ERROR_MESSAGES: Dictionary<{
  message: string;
}> = {
  [ERR_NETWORK]: {
    message: 'Please check your internet connection and refresh the page.',
  },
  [ERR_CANCELED]: {
    message: 'Please check your internet connection and refresh the page.',
  },
  [ECONNABORTED]: {
    message: 'Please check your internet connection and refresh the page.',
  },
  [ETIMEDOUT]: {
    message: 'Please check your internet connection and refresh the page.',
  },
};

export const DEFAULT_REDIRECTION_STATES: Dictionary<IRedirectionState> = {
  401: {
    url: `${DO_CENTRAL_SERVICE_URL}/login`,
    redirect: true,
  },
  ...GENERIC_ERROR_MESSAGES,
};

export const OFFLINE_MESSAGE =
  'You are currently offline. Please check your internet connection.';

export const NO_RESPONSE_MESSAGE = 'No response object in Axios error.';

export const UNEXPECTED_STATUS_MESSAGE = template`Received unexpected status code: ${'status'}`;

export const FALLBACK_MESSAGE = 'Error in while loading data.';
